module.exports = __webpack_public_path__ + "media/images/sp/stores/common/appeal_03-32e1460634771434f61720dd9c570781.jpg";